
<div class="item-grid-container px-3">
   
    <div class="report-grid">
      <ag-grid-angular
        style="width: 100%; height: 65vh"
        class="ag-theme-material"
        [rowHeight]="40"
        [enableFilter]="true"
        [enableSorting]="true"
        [enableColResize]="true"
        [rowSelection]="'single'"
        [rowData]="consumerLogsData"
        (gridReady)="onGridReady($event)"
        [columnDefs]="consumerLogsColumnDef"
        
      >
      </ag-grid-angular>
    </div>
  </div>